import {collection, field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";
import {EmployeeReportSelectionData} from "../../../employee/employee/controls/employee-report-selection-control.component";


export class SalesByHourReportData extends ReportData<SalesByHourReportData> {
    @collection() groupBy: string[] = ["none"];
    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];
    @field reportType: string = "SIMPLE";
    @field exclusive: boolean = true;
}
